import { jsx as _jsx } from "react/jsx-runtime";
import { useAemConfig } from '@as-react/common-components';
import { customerMutations, customerQueries } from '@as-react/common-queries';
import { FetchStatus } from '@as-react/common-types';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';
import { AccountCreditCard } from '../../components/account/account-credit-card/AccountCreditCard';
const AccountCreditCardContainer = ({ title }) => {
    const { defaultRequestParams, servicesEndpoint } = useAemConfig();
    const [deleteError, setDeleteError] = useState(false);
    const { getCardInfo } = customerQueries({ servicesEndpoint, defaultRequestParams });
    const { deleteCardMutation } = customerMutations({ servicesEndpoint, defaultRequestParams });
    const queryClient = useQueryClient();
    const { data: creditCards = [], isFetching, isError } = useQuery(getCardInfo());
    const { mutate: deleteCard } = useMutation(deleteCardMutation());
    const status = isFetching ? FetchStatus.PENDING : isError ? FetchStatus.REJECTED : FetchStatus.RESOLVED;
    const removeCard = (cardId) => {
        setDeleteError(false);
        deleteCard(cardId, {
            onSuccess: () => queryClient.invalidateQueries({ queryKey: getCardInfo().queryKey }),
            onError: () => setDeleteError(true),
        });
    };
    return (_jsx(AccountCreditCard, { ogoneAliases: creditCards, status: status, deleteError: deleteError, removeCard: removeCard, title: title }));
};
export default AccountCreditCardContainer;
